import type { LucideIcon } from "lucide-react";
import {
  Award,
  Sparkles,
  CreditCard,
  PlayCircle,
  HelpCircle,
} from "lucide-react";

/**
 * Single source of truth for the Landing page primary navigation.
 *
 * IMPORTANT (version safety):
 *   The Landing page header / mobile menu render whatever lives here.
 *   Adding or removing a nav link should be a one-line change to this
 *   array — do NOT edit the markup in `LandingHeader.tsx` /
 *   `LandingMobileMenu.tsx` for that purpose. Centralizing the list
 *   prevents future "accidental disappearance" of items like FAQ
 *   when an unrelated text edit triggers a stale-snapshot rewrite.
 */
export type LandingNavLink = {
  kind: "scroll";
  id: string;
  label: string;
  icon: LucideIcon;
};

export const LANDING_NAV_LINKS: ReadonlyArray<LandingNavLink> = [
  { kind: "scroll", id: "demo", label: "How It Works", icon: PlayCircle },
  { kind: "scroll", id: "certifications", label: "Certifications", icon: Award },
  { kind: "scroll", id: "features", label: "Features", icon: Sparkles },
  { kind: "scroll", id: "pricing", label: "Pricing", icon: CreditCard },
  { kind: "scroll", id: "faq", label: "FAQ", icon: HelpCircle },
] as const;

/** Smooth-scrolls to an in-page section by id. */
export function scrollToSection(id: string): void {
  if (typeof document === "undefined") return;
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
}

/** Smooth-scrolls the window back to the top. */
export function scrollToTop(): void {
  if (typeof window === "undefined") return;
  window.scrollTo({ top: 0, behavior: "smooth" });
}